import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';

@Component({
  selector: 'app-view-lab-result-details',
  templateUrl: './view-lab-result-details.component.html',
  styleUrls: ['./view-lab-result-details.component.scss']
})
export class ViewLabResultDetailsComponent implements OnInit {
  public stoolDetails
  public stoolColumns: string[] = ["name", "classification", "color", "consistency", "microscopy", "remarks", "method"];
  public xrayDetails = []
  public xrayColumns: string[] = ["name", "impressions", "remarks",];
  public rprDetails = []
  public rprColumns: string[] = ["name", "findings", "remarks",];

  constructor(
    public dialogRef: MatDialogRef<ViewLabResultDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private evaluatorService: EvaluatorService
  ) { }

  ngOnInit(): void {
    this.xrayDetails.push(this.data)
    this.rprDetails.push(this.data)
    if (this.data.resultTypeValue == '1') {
      this.evaluatorService.getStoolExamination(this.data.applicationId).subscribe(res => {
        this.stoolDetails = res
      })
    }
  }

}
